import styles from "./style.module.scss";

export const PriceSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Price<span>-料金-</span>
        </h2>
        <table>
          <thead>
            <tr>
              <th>宿泊人数</th>
              <th>
                料金 / 1泊
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1室1名</td>
              <td>20,000円</td>
            </tr>
            <tr>
              <td>1室2名</td>
              <td>20,000円</td>
            </tr>
            <tr>
              <td>1室3名</td>
              <td>25,000円</td>
            </tr>
            <tr>
              <td>1室4名</td>
              <td>25,000円</td>
            </tr>
          </tbody>
        </table>
        <p>
          ※ 全て一棟貸しでの合計料金（税込み）
          <br />
          ※ SANRIKU棟、JIGUNOMAKI棟両方とも同じ料金
        </p>
      </div>
    </section>
  );
};
